import { PageContainer } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const StyledPageContainer = styled(PageContainer)`
  && {
    max-width: 760px;
    padding-top: ${({ theme }) => theme.spacings.s};
  }
`;

export const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.xs};
`;
